import {Injectable} from '@angular/core';
import {StompConfig, StompRService} from '@stomp/ng2-stompjs';
import {AuthService} from '../security/authorization/auth.service';

@Injectable()
export class WebsocketService {
    constructor(private _stompService: StompRService, readonly _authService: AuthService) {}

    getWebSocket(webSocketUrl: string): StompRService {
        const _config: StompConfig = {
            url: webSocketUrl,
            headers: {},
            heartbeat_in: 0,
            heartbeat_out: 20000,
            reconnect_delay: 5000,
            debug: false,
        };
        this._stompService.config = _config;
        this._stompService.initAndConnect();
        return this._stompService;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/websocket/websocket.service.ts